import { render } from "./NewIncidenceModal.vue?vue&type=template&id=45561240"
import script from "./NewIncidenceModal.vue?vue&type=script&lang=js"
export * from "./NewIncidenceModal.vue?vue&type=script&lang=js"

import "./NewIncidenceModal.vue?vue&type=style&index=0&id=45561240&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__